let timeout
document.addEventListener("DOMContentLoaded", (event) => {
  if (BSS_B2B) {
    const targetNode = document.getElementById("cart-drawer");
    const config = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
          if (mutation.type === "attributes" && ["open", "role"].includes(mutation.attributeName)) {
            BSS_B2B.makeChangesAfterClickAjaxCart()
          }
        }, 500)
      }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  }
});
